import * as actions from './actions'
import * as getters from './getters'
import * as mutations from './mutations'

const state = {
  categories: {
    id: '0',
    list: {
      parent: {
        id: '0',
        name: ''
      },
      childs: []
    },
    currentId: ''
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/categories/index.js